var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"col-md-6":""}},[_c('TheFormData')],1),_c('v-flex',{attrs:{"col-md-6":""}},[_c('TheFormResult')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }